import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from '@/lib/analytics';

/** Hands every location change to analytics' page events (FIN-1154 PE-R14). Renders nothing. */
export function PageEventsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    recordPageView(pathname, search);
  }, [pathname, search]);
  return null;
}
